export const replaceNewLinesByBRtag = string =>
    string.replaceAll('\n', '<br />')
